/**
 * Decodes a base64 encoded auth token
 * @param {string} encodedToken - The base64 encoded token from URL
 * @returns {string|null} - The decoded token or null if invalid
 */
export const decodeAuthToken = (encodedToken) => {
  if (!encodedToken) {
    return null;
  }

  try {
    const decodedToken = atob(encodedToken);
    return decodedToken;
  } catch (error) {
    console.error("Failed to decode auth token:", error);
    return null;
  }
};
